import React from 'react'
import { Link } from 'react-router'
import { Button, Modal } from '@driftt/tide-core-legacy'

import './style.styl'

class ConfirmDefaultConfigurationModal extends React.Component {
  render() {
    const { onSave, onCancel } = this.props

    return (
      <Modal open={true} size="medium" onClose={onCancel} className="configuration-modal">
        <div className="configuration-modal-content">
          <div className="configuration-modal-header">
            <span className="configuration-modal-header-microcopy">Welcome to the Drift Assistant</span>
            <h1>Confirm the Drift Assistant&rsquo;s</h1>
            <h1>Configuration</h1>
          </div>
          <div className="configuration-modal-body">
            <p>
              After a meeting is held, or if a meeting is canceled or rescheduled, the Drift Assistant will
              remind your team to follow up if they haven&rsquo;t done so already via email or chat.
              We&rsquo;ll know which deals to remind your team about from the Salesforce mapping below.
            </p>
            <div className="configuration-default-value-container">
              <p>Your team will be reminded about:</p>
              <div className="configuration-default-value">Salesforce Leads</div>
              <span className="configuration-connector-dots" />
              <span className="configuration-connector">OR</span>
              <span className="configuration-connector-dots" />
              <div className="configuration-default-value">Open Opportunities</div>
            </div>
            <div className="configuration-default-value-container">
              <p>A demo is held when it matches this type of Salesforce activity:</p>
              <div className="configuration-default-value">Events</div>
            </div>
          </div>
          <div className="configuration-modal-button-section">
            <Button type="primary" size="medium" onClick={onSave}>
              Looks Good!
            </Button>
            <Button type="tertiary">
              <Link to="/settings/assistant/org">Customize Configuration</Link>
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ConfirmDefaultConfigurationModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfig/MeetingTaskConfig/ConfirmDefaultConfigurationModal/index.js